<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <span (click)="appService.navigateTo(node.route, node.venueRootSubdomain)">
            <span class="tree-node-icon-container" style="color:{{node.color}};margin-left: 6px;">
                <ng-container *ngIf="node.iconOverrideImagePath && node.iconOverrideImagePath !== ''; else defaultIconShortcut">
                    <img [src]="node.iconOverrideImagePath" class="node-icon-img" alt="icon" />
                </ng-container>
                <ng-template #defaultIconShortcut>
                    <mat-icon class="material-symbols-outlined">{{node.maticon}}</mat-icon>
                </ng-template>
            </span>
        </span>
    </mat-tree-node>
</mat-tree>
